import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import {
  AuthGuard,
  CmsConfig,
  ConfigModule,
  I18nModule,
  OccConfig,
  UrlModule
} from '@spartacus/core';
import { IconModule, SpinnerModule } from '@spartacus/storefront';
import { CustomOrderHistoryDetailComponent } from './components/custom-order-history-detail/custom-order-history-detail.component';
import { CustomOrderHistoryOverviewTableDefaultComponent } from './components/custom-order-history-overview/custom-order-history-overview-table-default/custom-order-history-overview-table-default.component';
import { CustomOrderHistoryOverviewTableRemainsComponent } from './components/custom-order-history-overview/custom-order-history-overview-table-remains/custom-order-history-overview-table-remains.component';
import { CustomOrderHistoryOverviewComponent } from './components/custom-order-history-overview/custom-order-history-overview.component';
import { CustomOrderHistoryAdapter } from './custom-order-history.adapter';
import { CustomOrderHistoryEffects } from './store/custom-order-history.effects';
import {
  customOrderHistoryFeatureKey,
  customOrderHistoryReducer
} from './store/custom-order-history.reducer';
import { UigCustomHistoryGuard } from './uig-custom-history.guard';

@NgModule({
  declarations: [
    CustomOrderHistoryOverviewComponent,
    CustomOrderHistoryOverviewTableDefaultComponent,
    CustomOrderHistoryOverviewTableRemainsComponent,
    CustomOrderHistoryDetailComponent,
  ],
  imports: [
    ConfigModule.withConfig({
      backend: {
        occ: {
          endpoints: {
            customOrderHistory: '/myrio/orderhistory/search',
            customOrderHistoryDownload: '/myrio/orderhistory/download',
            customOrderHistoryCancelOrder: '/myrio/orderhistory/cancel',
            orderDetail: '/myrio/orderhistory/order/${orderId}',
            orderDetailDownload: '/myrio/orderhistory/order/download/${orderId}',
            customOrderHistoryCancelOrderEntry:
              '/myrio/orderhistory/cancel/entry',
            customOrderHistoryUpdateOrderEntries: '/myrio/orderhistory/update',
          },
        },
      },
    } as OccConfig),
    ConfigModule.withConfig({
      cmsComponents: {
        AccountOrderHistoryComponent: {
          component: CustomOrderHistoryOverviewComponent,guards :[AuthGuard ,UigCustomHistoryGuard]
        },
        AccountOrderDetailsShippingComponent: {
          component: CustomOrderHistoryDetailComponent,guards :[AuthGuard ,UigCustomHistoryGuard]
        },
      }
    } as CmsConfig),
    StoreModule.forFeature(
      customOrderHistoryFeatureKey,
      customOrderHistoryReducer
    ),
    EffectsModule.forFeature([CustomOrderHistoryEffects]),
    I18nModule,
    RouterModule,
    UrlModule,
    CommonModule,
    NgSelectModule,
    FormsModule,
    SpinnerModule,
    IconModule
  ],
  providers: [
    {
      provide: CustomOrderHistoryAdapter,
      useClass: CustomOrderHistoryAdapter,
    },
  ],
})
export class CustomOrderHistoryModule {}
